export const MULTI_SELLER_EXPERIMENT_ID = 'multi-seller';
export const MULTI_SELLER_TREATMENT_VARIANT = 'multi-seller-a';
export const MULTI_SELLER_SIZE_SELECTED_SHEET_SUFFIX = ':sizeSelectorSheet';
export const MULTI_SELLER_POPUP_SUFFIX = ':sellerpopup';
export const MULTI_SELLER_POPUP_OPEN = 'multi_seller_popup_open';
export const SELLER_DETAILS_POPUP_OPEN = 'seller_details_popup_open';
